import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import { useCostLinesStore } from "entities/CostLines/store/useCostLinesStore";
import { useTranslation } from "react-i18next";
import Icons from "shared/icons";
import { Loader } from "shared/ui";
import "./CostLineHeader.styles.css";
import { getCostLineDecisions } from "entities/CostLines";

function CostLineHeader({ costLine, canDelete, userRole }) {
  const { t } = useTranslation("CostLine");
  const costLinesState = useCostLinesStore((state) => state.costLinesState);
  const deleteCostLine = useCostLinesStore((state) => state.deleteCostLine);

  const { isAccepted, isRejected } = getCostLineDecisions(costLine, userRole);

  const handleCostLineRemoval = (e, id) => {
    e.stopPropagation();
    deleteCostLine(id);
  };

  return (
    <div className="d-flex w-100 gap-4 justify-content-end align-items-center me-4 ms-auto">
      <div className="me-auto ms-3">
        {(isAccepted || isRejected) && (
          <span
            className={`d-flex align-items-center ${
              isRejected ? "text-danger" : ""
            } ${isAccepted ? "text-success" : ""} `}
          >
            <FontAwesomeIcon icon={isRejected ? Icons.xmark : Icons.check} />
            <small className="ms-2 fw-bolder">
              {isAccepted ? t("accepted") : isRejected ? t("rejected") : null}
            </small>
          </span>
        )}
      </div>
      <>
        {costLinesState[costLine.id]?.isModified && (
          <span className="text-info d-flex align-items-center">
            <FontAwesomeIcon
              shake
              icon={Icons.circleExclamation}
              className="me-3"
            />
            <small>{t("unsaved_changes")}</small>
          </span>
        )}
      </>

      <>
        {costLinesState[costLine.id]?.hasErrors && (
          <FontAwesomeIcon
            className="text-danger"
            icon={Icons.triangleExclamation}
          />
        )}
      </>
      {costLinesState?.[costLine.id]?.isSaving ? (
        <Loader size="sm">{t("saving")}</Loader>
      ) : costLinesState?.[costLine.id]?.isDeleting ? (
        <Loader size="sm">{t("deleting")}</Loader>
      ) : (
        canDelete && (
          <IconButton onClick={(e) => handleCostLineRemoval(e, costLine.id)}>
            <FontAwesomeIcon
              icon={Icons.trash}
              className="cost-line-header__icon"
            />
          </IconButton>
        )
      )}
    </div>
  );
}

export default CostLineHeader;
